import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import styles from "./SwatchItem.module.scss";

export type SwatchItemProps = {
  color: string;
  isSelected?: boolean;
  isOutOfStock?: boolean;
  label: string;
  disabled?: boolean;
} & Omit<SafeHtmlAttributes<HTMLButtonElement>, "color">;

export const SwatchItem = ({ color, isSelected = false, isOutOfStock = false, label, ...rest }: SwatchItemProps) => (
  <button
    type="button"
    className={classnames(styles.swatchItem, isSelected && styles.selected)}
    aria-label={label}
    aria-pressed={isSelected}
    {...rest}
  >
    <span className={styles.swatch} style={{ backgroundColor: color }} />
    {isOutOfStock && (
      <span className={styles.outOfStock}>
        <span className={styles.outOfStockLine} />
      </span>
    )}
  </button>
);
